import React from 'react'
import LineSvg from '../../Components/SVG/LineSvg'

const skills = [
    {
        name: '.NET Framework',
        years: '4 years'
    },
    {
        name: 'Angular',
        years: '5 years'
    },
    {
        name: 'Ionic',
        years: '2 years'
    },
    {
        name: 'Docker',
        years: '2 years'
    },
    {
        name: 'React',
        years: '1 year'
    },
    {
        name: 'MSSQL',
        years: '1 year'
    },
    {
        name: 'POSTGRESQL',
        years: '2 year'
    },
    {
        name: 'Tailwind CSS',
        years: '1 year'
    },
    {
        name: 'Bootstrap CSS',
        years: '4 year'
    }
]

const Skills = () => {
  return (
    <div className="relative mt-36">
    <LineSvg className={`left-0 right-0 -top-10 m-auto absolute w-[10em]`} />
    <p className=' text-xl font-bold underline'>Tech Skills</p>
    <p className='text-secondary container m-auto md:max-w-[90%] lg:max-w-[70%] flex flex-wrap justify-center'>
      {
        skills.map((s, i) => 
            <div key={i} className=' border border-secondary mr-2 my-1 text-sm'> 
                <span className='px-2 py-1 text-white bg-appRed'>{s.name}</span>
                <span className='px-2 py-1'>{s.years}</span>
            </div> 
        )
      }
    </p>
    <LineSvg className={`left-0 right-0 m-auto -bottom-10 absolute w-[10em] rotate-180`} />
  </div>
  )
}

export default Skills
